import { bindable } from 'aurelia-framework';

export class FinancialEntrySourceSelect {
	@bindable financialEntrySourceFilter: string;
	filterOptions: string[] = [
		'Original',
		'Original_ManualTransfer',
		'Not_ExternalMunicipalitiesDivision'
	];
}
